module.exports = "<div class=\"verify-email-page\"><div class=\"alert alert-success\" ng-if=\"ctrl.status\">You have successfully verified your email address.</div><div class=\"alert alert-warning\" ng-if=\"!ctrl.status\">Sorry, there's been an error.</div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/guest/verifyEmail/template.pug
 ** module id = 856
 ** module chunks = 0
 **/